var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"flex items-center relative",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"arrow-icon__line"}),_c('CIcon',{staticClass:"arrow-icon__arrow-head",attrs:{"name":"arrow-right"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }